import { Theme } from "../../../../components/constants";

export default {
    transactionDetails: {
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        rowGap: "6px",
    },

    transactionLabel: {
        fontSize: "16px",
    },

    columnGap: {
        marginTop: "80px"
    },

    amountBox: {
        marginTop: "40px",
        cursor: "pointer"
    },

    card: {
        marginTop: "20px"
    },

    bankName: {
        margin: "0"
    },

    cardInformation: {
        display: "flex",
        columnGap: "10px",
        justifyContent: "center",
        alignItems: "center"
    },

    actionButtons: {
        margin: "35px 0",
        display: "flex",
        columnGap: "40px"
    },

    iconLabelContainer: {
        columnGap: "6px",
        cursor: "pointer"
    },

    cvvInfo: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#215DAA"
    },

    cvvDetails: {
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "end",
        rowGap: "5px"
    },

    cvvInput: {
        width: "60%"
    },

    cardText: {
        fontSize: "14px"
    },

    pointer: {
        cursor: "pointer"
    },

    cardFormBtnContainer: {
        display: "flex",
        columnGap: "14px",
        marginTop: "22px"
    },

    cardFormBtn: {
        padding: "5px 18px"
    },

    paynowBtnContainer: {
        marginTop: "59px",
        textAlign: "right"
    },

    paynowButton: {
        width: "120px"
    },

    switchContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        margin: "20px 0px 22px"
    },

    saveCardSwitch: {
        display: "flex",
        marginRight: "8px"
    },

    switchLabelStyle: {
        width: "28px",
        height: "14px",
    },

    switchButtonStyle: {
        top: "1px",
        width: "10px",
        height: "10px"
    },

    switchText: {
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT
    },

    labelsContainer: {
        display: "flex",
        flexDirection: "column",
        rowGap: "20px",
    },

    capitalize: {
        textTransform: "uppercase"
    },

    alternatePaymentOptions: {
        display: "flex",
        alignItems: "center",
        marginTop: '10px',
        columnGap: "8px"
    },

    linkBtn: {
        color: Theme.TEXT_PRIMARY,
        fontSize: "16px",
        fontWeight: "700"
    },
    cardPaymentTypeContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        justifyContent: "space-evenly",
        marginBottom: "20px",
    },

    individualCardStyle: {
        height: "100px",
        width: "auto",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    
    cardHeader: {
        marginTop: 0,
        marginBottom: 0,  
    },

    disabledCardStyle: {
        background: Theme.DISABLED_INPUT,
        cursor: "not-allowed",
    }
}